import { ReadingStatus } from 'infrastructure/enums';
import i18n from 'infrastructure/i18n';
import classNames from 'classnames';

import s from './styles.module.scss';

import type { FC } from 'react';

interface Props {
  status: ReadingStatus;
  count: number;
  disable?: boolean;
}

const labels = {
  [ReadingStatus.Critical]: i18n.t('labels.critical'),
  [ReadingStatus.Risk]: i18n.t('labels.atRisk'),
  [ReadingStatus.Normal]: i18n.t('labels.normal'),
};

const ReadingsBlock: FC<Props> = ({ status, count, disable }) => {
  return (
    <div
      className={classNames(s['block-wrapper'], {
        [s[status]]: count > 0,
        [s.disable]: disable,
      })}
    >
      <div className={s.block}>
        <div className={s['block-title']}>{labels[status]}</div>
        <div className={s['block-count']}>{count}</div>
      </div>
    </div>
  );
};

export default ReadingsBlock;
